
<!-- 根据区域检索摄像头 -->
<template>
  <div class="app-area-list">
    <div class="search-box">
      <el-input
        v-model="searchDevice"
        clearable
        style="width: 100%"
        :placeholder="$t('business.placeholder.keyword')"
      >
      </el-input>
      <!-- <span> | </span> -->
      <!-- <img
        src="@src/common/assets/images/search.png"
        alt=""
      /> -->
    </div>
    <div
      class="filter_actions"
      style="margin: 5px 5px 10px 0"
      v-show="cameraData.length > 0 && isCollection"
    >
      <div>
        <el-button
          type="primary"
          @click="handleCollection(cameraData)"
          style="padding: 2px 1px"
          icon="iconfont icon-xinzeng"
          >{{ $t("video.label.addFavorite") }}</el-button
        >
        <!-- <span @click="handleCollection(cameraData)"
              style="margin-right: 5px">{{$t('video.label.addFavorite')}}</span> -->
      </div>
      <label @click="getChosenCount" class="font-default-color"
        >{{ $t("video.label.selected") }} {{ cameraData.length }}
        {{ $t("video.label.a") }}</label
      >
    </div>
    <div class="area-container">
      <el-scrollbar ref="scrollBar" class="scroll-bar">
        <el-tree
          class="full-height"
          v-if="showTree"
          ref="appDeviceGroupTree"
          :data="dataList"
          node-key="id"
          :props="defaultProps"
          :show-checkbox="multiCheck"
          highlight-current
          :default-expanded-keys="expandedKeys"
          :default-checked-keys="defaultCheckedKeys"
          :filter-node-method="filterNode"
          @node-click="getCheckNode"
          @check="checkChange"
        >
          <div
            style="-moz-user-select: none"
            class="node"
            :title="data.name"
            slot-scope="{ data }"
            :draggable="data.nodeType == 'device' ? true : false"
            :class="[
              {
                'out-line':
                  parseInt(data.status) !== 1 && data.nodeType === 'device',
              },
              data.color,
              data.nodeType == 'device' ? 'showDrag' : '',
            ]"
            @dblclick="deviceChoose(data)"
          >
            <div class="node-cover"></div>
            <i
              v-show="data.nodeType === 'area'"
              :class="[areaIcon(data), 'area-node-icon']"
            ></i>
            <i
              v-show="data.nodeType === 'device'"
              :style="{ color: data.color }"
              class="iconfont-lunan icon-lunan-shexiangtou"
            ></i>
            <!-- <span :style="{color: data.color}">{{data.name}}</span> -->
            <span
              style="
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
              "
              >{{ data.name }}</span
            >
            <i
              v-show="data.nodeType === 'device'"
              :class="[
                'icon',
                'iconfont-lunan',
                cameraIcon(data),
                'camera-type-icon',
              ]"
            ></i>
          </div>
        </el-tree>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import { Cache } from "$utils";
import { api } from "../api";
const trim = (str) => {
  return str.replace(/^\s+|\s+$/g, "");
};
export default {
  props: {
    multiCheck: {
      type: Boolean,
      default: false,
    },
    showPercentage: {
      type: Boolean,
      default: true,
    },
    isCollection: {
      type: Boolean,
      default: false,
    },
    defaultCheckedKeys: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    searchDevice(val) {
      this.$refs.appDeviceGroupTree.filter(val);
    },
  },
  data() {
    return {
      dataList: [],
      defaultProps: {
        children: "children",
        label: "name",
        id: "id",
      },
      searchDevice: "",
      cameraData: [],
      searchDeviceChange: false,
      // 默认展开的数组
      expandedKeys: [],
      showTree: true,
    };
  },
  mounted() {
    // this.queryDevice()
  },
  methods: {
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },

    cameraIcon(data) {
      switch (data.ability) {
        case "0":
          return "";
        case "1":
          return "icon-lunan-renyuanbukong";
        case "2":
          return "icon-lunan-cheliangbukong";
        // case '3':return 'icon iconfont icon-b_icon__cam_hem';
        default:
          return "";
      }
    },
    areaIcon(data) {
      const account = Cache.get("CACHE_USER_INFO");
      if (account.parkInfo.areaDevGroupCode === data.id) {
        return this.$config.fontFamily + " ioc-Build";
      } else {
        return "el-icon-office-building";
      }
    },
    // 查询区域树
    queryDevice(data) {
      this.dataList = [];
      let params = {
        deviceType: "10",
        distance: data.distance,
        emergencyRecordCode: data.emergencyRecordCode,
      };
      // /bms/device/queryDeviceWorkGroupDeviceTree.json
      // api.reserve.getDeviceList
      this.$fetch(api.reserve.getDeviceList, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        } else {
          const account = Cache.get("CACHE_USER_INFO");
          if (this.searchDevice != "") {
            if (response.returnObj && response.returnObj.length) {
              this.areaNameList = this.deviceDataPro(response.returnObj);
              this.dataList = response.returnObj;
              this.checkChildNodes(this.searchDevice, response.returnObj);
            } else {
              this.expandedKeys = [account.parkInfo.areaDevGroupCode];
              this.dataList = [];
            }
          } else {
            this.expandedKeys = [account.parkInfo.areaDevGroupCode];
            let result = response.returnObj;
            this.areaNameList = this.deviceDataPro(result);
            this.dataList = result;
            result = null;
          }
        }
      });
    },
    deviceDataPro(devices, parentName) {
      let list = {};
      if (devices && devices.length) {
        devices.forEach((item) => {
          if (item.nodeType === "device") {
            list[item.id] = {
              areaName: parentName,
              ...item,
            };
          } else if (item.nodeType === "area") {
            list = Object.assign(
              list,
              this.deviceDataPro(item.children, item.name)
            );
          }
        });
      }
      return list;
    },
    handleCollection(data) {
      this.$emit("handleCollection", data);
    },
    searchBtnClick() {
      if (this.searchDevice == "" && !this.searchDeviceChange) return;
      this.queryDevice();
    },
    getChosenCount() {
      return this.cameraData.length;
    },
    resetSelect() {
      this.$refs.appDeviceGroupTree.setCheckedNodes([]);
      this.cameraData = [];
      this.$emit("cameraData", [], []);
    },
    // 双击
    deviceChoose(nodeData) {
      if (nodeData.nodeType != "area") {
        if (nodeData.status != 1) {
          this.$message.warning(this.$t("business.message.offline"));
          return;
        }
        this.$emit("deviceChoose", nodeData);
      }
    },
    // 单击
    getCheckNode(nodeData) {
      if (nodeData.nodeType !== "area") {
        this.$emit("deviceClick", nodeData);
      } else {
        this.$emit("areaClick", nodeData);
      }
    },
    // 业务页面获取选中的设备/区域列表
    getCheckedNodes() {
      return {
        area: this.checkedArea || [],
        device: this.checkedDevice || [],
      };
    },
    // 多选
    checkChange(node, checkData) {
      this.$log.info("摄像机选中节点", node);
      // 当前被选中节点
      let checkNodes = checkData.checkedNodes;
      this.checkedArea = [];
      this.checkedDevice = [];
      checkNodes.forEach((item) => {
        if (item.nodeType != "area") {
          this.checkedDevice.push(item);
        } else {
          this.checkedArea.push(item);
        }
      });
      this.cameraData = this.checkedDevice;
      this.$emit("cameraData", this.checkedDevice, this.checkedArea);
    },
    // 判断是否含有子节点
    checkChildNodes(str, arr) {
      for (let item of arr) {
        if (item.name.search(str.trim()) != -1) {
          this.expandedKeys.push(item.id);
        }
        if (item.children.length > 0) {
          this.checkChildNodes(str, item.children);
        }
      }
    },
    resetScroll() {
      setTimeout(() => {
        this.$refs.scrollBar.update();
      }, 500);
    },
    setChecked(deviceId) {
      this.$refs.appDeviceGroupTree.setCheckedKeys(deviceId);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.app-area-list {
  .showIcon {
    @include set_theme_color(color, main-theme-color);
    &:hover {
      color: #fff;
    }
  }
  height: 100%;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;

  .search-box {
    margin-bottom: 10px;
    background: #0d121c;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    :deep .el-input__inner {
      // background: ##0D121C;
      border: none !important;
      height: 30px;
    }
    span {
      height: 20px;
    }
    img {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
  .showDrag {
    max-width: 260px;
  }
  .node {
    position: relative;
    display: flex;
    width: 100%;
    .node-cover {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    &.out-line {
      color: #757373;
      .icon {
        color: #757373;
      }
    }
    .camera-type-icon {
      text-align: right;
      flex: 1;
      margin-right: 10px;
    }
  }
  .area-container {
    flex: 1;
    overflow: hidden;

    .area-node-icon {
      margin-right: 5px;
    }
    .iconfont-lunan {
      margin-right: 5px;
    }
  }
  .scroll-bar {
    height: 100%;
    z-index: 1;
    .full-height {
      padding: 5px 0;
      /deep/.el-tree-node__content {
        height: 30px;
        &:hover {
          @include set_theme_color(background-color, item-active-bg-color);
        }
      }
    }
    .el-scrollbar__wrap {
      overflow-x: hidden;
      height: 100%;
      margin-bottom: 0px !important;
    }
  }
}
</style>


